/* Responsive behavior: no polling, page hiding, or duplicated cart handler. */
(() => {
  const touch = () => matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)').matches;
  const root = () => window.Shopify?.routes?.root || '/';
  function saved() { try { return JSON.parse(localStorage.getItem('asm-favorites') || '[]'); } catch { return []; } }
  function placeMenu(panel) {
    panel.style.removeProperty('left'); panel.style.removeProperty('right');
    const r = panel.getBoundingClientRect();
    if (r.left < 8) { panel.style.setProperty('left', '0', 'important'); panel.style.setProperty('right', 'auto', 'important'); }
  }
  function centerHeaderLogo() {
    document.querySelectorAll('.header').forEach(header => {
      if (!touch()) { header.style.removeProperty('--asm-header-midpoint'); return; }
      const logo = header.querySelector('.header__heading-logo, .header__heading-link');
      if (!logo) return;
      header.style.setProperty('--asm-header-midpoint', '50%');
      const bounds = logo.getBoundingClientRect();
      const offset = document.documentElement.clientWidth / 2 - (bounds.left + bounds.right) / 2;
      header.style.setProperty('--asm-header-midpoint', `calc(50% + ${offset}px)`);
    });
  }
  function finishCards(scope) {
    if (!touch()) return;
    scope.querySelectorAll('[data-asm-product-card] .asm-cart-button').forEach(button => {
      if (button.querySelector('svg')) return;
      const icon = document.createElementNS('http://www.w3.org/2000/svg','svg');
      icon.setAttribute('viewBox','0 0 24 24'); icon.setAttribute('aria-hidden','true'); icon.classList.add('asm-inline-icon');
      icon.innerHTML = '<path d="M3 4h2l2 11h11l3-8H6"/><circle cx="9" cy="20" r="1.2"/><circle cx="18" cy="20" r="1.2"/>';
      const label = document.createElement('span'); label.textContent = button.textContent.trim() || 'Sifarişə əlavə et';
      button.replaceChildren(icon,label);
    });
  }
  function initializeHelp() {
    const trigger = document.querySelector('[data-asm-help-open]');
    const dialog = document.getElementById('asm-touch-help-dialog');
    if (!trigger || !dialog) return;
    if (trigger.dataset.asmHelpBound) return;
    trigger.dataset.asmHelpBound = 'true';
    const phone = matchMedia('(max-width:749px)');
    trigger.addEventListener('click', () => {
      if (!phone.matches || dialog.open) return;
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
    });
    dialog.querySelector('[data-asm-help-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); });
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    phone.addEventListener('change', event => { if (!event.matches && dialog.open) dialog.close(); });
  }
  function placeBenefits() {
    document.querySelectorAll('.asm-home').forEach(home => {
      const primary = home.querySelector(':scope > aside.asm-home-benefits');
      const newProducts = home.querySelector('#asm-new-products');
      const cards = [...home.querySelectorAll('[data-asm-benefit-after-new]')];
      if (!primary || !newProducts || cards.length !== 2) return;
      let secondary = home.querySelector('.asm-home-benefits--after-new');
      if (touch()) {
        if (!secondary) {
          secondary = document.createElement('aside');
          secondary.className = 'asm-home-benefits asm-home-benefits--after-new';
          secondary.setAttribute('aria-label', 'Təhvil və keyfiyyət');
          newProducts.after(secondary);
        }
        cards.forEach(card => secondary.append(card));
        home.classList.add('asm-benefits-split');
      } else {
        cards.forEach(card => primary.append(card));
        secondary?.remove();
        home.classList.remove('asm-benefits-split');
      }
    });
  }
  function ready() {
    centerHeaderLogo();
    placeBenefits();
    finishCards(document);
    document.querySelectorAll('[data-asm-carousel]').forEach(carousel => {
      if (carousel.dataset.asmTouchObserved) return;
      carousel.dataset.asmTouchObserved='true';
      new MutationObserver(changes => { if (changes.some(c => [...c.addedNodes].some(n => n.nodeType===1 && (n.matches('[data-asm-product-card]') || n.querySelector('[data-asm-product-card]'))))) finishCards(carousel); }).observe(carousel,{childList:true,subtree:true});
    });
    const nav = document.querySelector('.asm-touch-nav');
    if (nav && location.search.includes('view=asm-favorites')) nav.querySelector('a[href*="asm-favorites"]')?.setAttribute('aria-current', 'page');
    initializeHelp();
    document.querySelectorAll('.asm-mobile-bottom,.asm-mobile-global-nav').forEach(el => el.remove());
    document.querySelectorAll('[data-asm-choice-toggle]').forEach(button => button.addEventListener('click', () => {
      if (!touch()) return;
      requestAnimationFrame(() => { const panel = button.closest('.asm-product__choice')?.querySelector('.asm-product__choice-popover'); if (panel) placeMenu(panel); });
    }));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('.asm-product__choice.is-open').forEach(el => { el.classList.remove('is-open'); el.querySelector('button')?.setAttribute('aria-expanded','false'); }); });
    const track = document.querySelector('[data-asm-favorites-track]');
    if (track) {
      const ids = saved();
      Promise.all(ids.map(id => fetch(root() + 'products/' + encodeURIComponent(id) + '?view=asm-favorite-card').then(r => r.ok ? r.text() : '').catch(() => ''))).then(cards => {
        track.innerHTML = cards.join('');
        const empty = document.querySelector('.asm-favorites-empty'); if (empty) empty.hidden = !!track.childElementCount;
        const home = track.closest('[data-asm-home]'); if (home && typeof ASMHomeSections !== 'undefined') new ASMHomeSections(home);
      });
    }
    initializeHero();
  }
  function initializeHero() {
    const hero = document.querySelector('.asm-home .asm-hero');
    if (hero && touch()) {
      const image = hero.querySelector('.asm-touch-hero-image') || hero.querySelector('.asm-hero__image');
      const slides = [...hero.querySelectorAll('[data-asm-hero-slide]')].map(el => el.dataset.asmHeroSlide).filter(Boolean);
      if (image && slides.length > 1 && !hero.querySelector('.asm-hero-pagination')) {
        let selected = 0;
    const dots = document.createElement('div'); dots.className = 'asm-hero-pagination'; dots.setAttribute('aria-label','Banner şəkilləri');
        slides.forEach((src, index) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `${index+1}-ci slayd`); b.setAttribute('aria-current',String(index === selected)); b.onclick = () => { image.src = src; image.srcset = ''; selected = index; [...dots.children].forEach((d,i) => d.setAttribute('aria-current',String(i === index))); }; dots.append(b); });
        hero.append(dots);
      }
    }
  }
  window.addEventListener('click', event => {
    if (!touch() || !(event.target instanceof Element)) return;
    const button = event.target.closest('[data-asm-product-card] .asm-qty button');
    if (!button) return;
    const card = button.closest('[data-asm-product-card]');
    const field = card?.querySelector('[data-asm-qty]');
    const hidden = card?.querySelector('[data-asm-form-qty]');
    if (!field || !hidden) return;
    event.preventDefault();
    event.stopPropagation();
    const next = Math.max(1, Math.min(999, (parseInt(field.value, 10) || 1) + (button.hasAttribute('data-asm-qty-minus') ? -1 : 1)));
    field.value = String(next);
    hidden.value = String(next);
    const minus = card.querySelector('[data-asm-qty-minus]');
    if (minus) { minus.disabled = next <= 1; minus.setAttribute('aria-disabled', String(next <= 1)); }
  }, true);
  document.addEventListener('DOMContentLoaded',ready,{once:true});
  document.addEventListener('shopify:section:load',ready);
  window.addEventListener('resize',centerHeaderLogo,{passive:true});
  matchMedia('(max-width:989px), (max-width:1366px) and (pointer:coarse)').addEventListener('change', () => {
    placeBenefits();
    if (touch()) { finishCards(document); initializeHero(); }
  });
})();
